import { useState } from 'react';
import { StyledCheckbox, StyledCheckboxContainer } from './Checkbox.styled';
import { CheckboxChecked, CheckboxUnchecked } from '../../svgs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A barebones checkbox `input` following the base campaign pages theme.
 * All native HTML checkbox behaviors are supported.
 * Use the `CheckboxWithTooltip` molecule for checkbox with label and tooltip.
 *
 * **Internal-only component!**
 * - Common styling per the design system for shape and layout.
 * - No custom behavior beyond the HTML element's native behavior.
 * - No custom props.
 */
export const Checkbox = _ref => {
  let {
    onChange,
    ...rest
  } = _ref;
  const [checked, setChecked] = useState(rest.checked);
  return /*#__PURE__*/_jsxs(StyledCheckboxContainer, {
    checked: checked,
    children: [/*#__PURE__*/_jsx(StyledCheckbox, {
      type: "checkbox",
      onChange: e => {
        setChecked(e.target.checked);
        if (onChange) {
          onChange(e);
        }
      },
      ...rest
    }), checked ? /*#__PURE__*/_jsx(CheckboxChecked, {}) : /*#__PURE__*/_jsx(CheckboxUnchecked, {})]
  });
};